<template>
  <div class="selectpk">
    {{ title }}
    <pkcs8upload @PKCS8UploadEvent="newfiles" @cancelEvent="cancel" />

<!--     <p v-show="serial" >serial:  {{ serial }}</p> -->
<!--     <p v-show="subject">subject: {{ subject }}</p> -->
<!--     <p v-show="issuer" >issuer:  {{ issuer }}</p> -->

  </div>
</template>
<script>
import pkcs8upload from './upload'
// import {} from '@/ParseEfirmaLib.js'
import * as jsrsasign from 'jsrsasign'
import { mapActions } from 'vuex';
export default {
  name: 'ParseEfirma',
  components: {
    pkcs8upload
  },
  data () {
    return {
      title: '',
      subject: '',
      issuer: '',
      serial: ''
    }
  },
  methods: {
    ...mapActions(['setKey']),
    async newfiles (pk) {
      console.debug('newfiles %o', pk)
      let save = pk.save;
      let cert = this.parseX509(pk.cer)
      let key = await this.parsePKCS8(pk.key, pk.password)
      if (Object.keys(key).length === 0) {
        return
      } else if (!this.isValidCertKeyPair(cert, key)) {
        this.$toast.error('El certificado y la llave no concuerdan.')
        return
      }
      this.$emit('PrivateKeyUploadEvent', { name: this.subject, serial: this.serial, issuer: this.issuer, cer: cert, 'key': key, 'save': save})
    },
    cancel (event) {
      this.$emit('PrivateKeyUploadEvent')
    },
    parseX509 (certificateBuffer) {
      let certPem = jsrsasign.KJUR.asn1.ASN1Util.getPEMStringFromHex(jsrsasign.rstrtohex(certificateBuffer), 'CERTIFICATE')
      console.debug('certPem %s', certPem)
      var c = new jsrsasign.X509()
      c.readCertPEM(certPem)
      this.serial = c.getSerialNumberHex()
      this.issuer = c.getIssuerString()
      this.subject = c.getSubjectString()
      var sNotBefore = c.getNotBefore()
      var sNotAfter = c.getNotAfter()
      console.debug('cert.serial: %s', this.serial)
      return c
    },
    async parsePKCS8 (pkBuffer, password) {
      try{
        console.debug('parsePKCS8 pk pass:%o buf: %o', password, pkBuffer)
        let hexPK = jsrsasign.rstrtohex(pkBuffer)
        console.debug('parsePKCS8 pk hex: %o', hexPK)
        let prvp8pem = jsrsasign.KJUR.asn1.ASN1Util.getPEMStringFromHex(hexPK, 'ENCRYPTED PRIVATE KEY')
        console.debug('parsePKCS8 pk pem: %o', prvp8pem)
        this.setKey(prvp8pem);
        // Cualquiera de los dos siguientes funciona:
        // let keyObj = jsrsasign.KEYUTIL.getKey(prvp8pem, password)
        let keyObj = jsrsasign.KEYUTIL.getKeyFromEncryptedPKCS8PEM(prvp8pem, password)
        console.debug('parsePKCS8 pk obj: %o', keyObj)
        return keyObj
      }catch(e){
        console.error('parsePKCS8 error: %o', e)
        this.$toast.error("Contraseña incorrecta.");
        return {}
      }
    },
    isValidCertKeyPair(cert, key) {
      // Parameters
      const testString = 'qwertyuiop'
      const alg = 'SHA1withRSA'
      const prov = 'cryptojs/jsrsa'
      // Signature with private key
      let sigPrivate = new jsrsasign.KJUR.crypto.Signature({alg, prov})
      sigPrivate.init(key)
      sigPrivate.updateString(testString)
      const signature = sigPrivate.sign()
      console.debug('SHA1WithRSA: %o', signature);
      // Verification with public key
      let certPem = jsrsasign.KJUR.asn1.ASN1Util.getPEMStringFromHex(cert.hex, 'CERTIFICATE')
      let sigPublic = new jsrsasign.KJUR.crypto.Signature({alg, prov})
      sigPublic.init(certPem)
      sigPublic.updateString(testString)
      // returns boolean
      const v = sigPublic.verify(signature);
      return v
    },
  }
};
</script>
<style scoped>
.selectpk { border: 1px solid red; }
</style>
